import { render, staticRenderFns } from "./start.vue?vue&type=template&id=185f9435&scoped=true&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f9435",
  null
  
)

export default component.exports